exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game-player-thrown .label[data-v-3461dc5c]{font-size:2.3vw;line-height:2.3vw!important;color:#fff}", ""]);

// exports
